import React, { ReactNode } from 'react';

export interface ExpandingBoxColumnProps {
  children: ReactNode;
  isExpanded: boolean;
  className?: string;
  expandedClassName?: string;
  contractedClassName?: string;
}

/**
 * ExpandingBoxColumn Component
 *
 * A reusable component that expands or contracts its width based on the isExpanded prop.
 * Typically used for the right column that needs to expand when the left column is collapsed.
 *
 * @param children - The content to display inside the expanding column
 * @param isExpanded - Whether the column should be expanded (takes full width)
 * @param className - Base CSS classes for the container div (optional)
 * @param expandedClassName - CSS classes applied when expanded (optional)
 * @param contractedClassName - CSS classes applied when contracted (optional)
 */
export const ExpandingBoxColumn: React.FC<ExpandingBoxColumnProps> = ({
  children,
  isExpanded,
  className = 'flex flex-col w-full transition-all duration-300',
  expandedClassName = 'lg:w-full md:w-full',
  contractedClassName = 'lg:w-auto md:w-full',
}) => {
  const dynamicClasses = isExpanded ? expandedClassName : contractedClassName;

  return <div className={`${className} ${dynamicClasses}`}>{children}</div>;
};
